import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormContainerComponent } from "../form/form-container/form-container.component";
import { Props, DynamicFormArray } from '../../model/form.model';
import { CommonModule } from '@angular/common';
import { breadrums } from '../../model/breadcrum.model';
import { BreadcrumsComponent } from '../../components/breadcrums/breadcrums.component';
import { DataTableSchema } from '../../model/dynamic-data-table.model';
@Component({
  selector: 'app-search-container',
  standalone: true,
  imports: [FormContainerComponent, CommonModule, BreadcrumsComponent],
  templateUrl: './search-container.component.html',
  styleUrl: './search-container.component.scss'
})
export class SearchContainerComponent implements OnInit {
  @Input() DataTableSchema?: DataTableSchema;
  @Input() renderFlag: any;
  @Input() props!: Props;
  @Input() showTitle = true;
  @Input()
  dynamicFormArray!: DynamicFormArray;
  valueChanged: string | undefined;
  @Input() shareData: any;
  @Input() title!: string;
  @Output() closeDialog = new EventEmitter<any>();
  breadcrumList: Array<breadrums> = [];

  ngOnInit() {
    if (this.title) {
      this.breadcrumList = [{ level: 1, name: this.title || '' }]
    }
    this.dynamicFormArray.title ??= 'SEARCH CRITERIA';
  }
  closeBtnOnClick(_event: any) {
    this.closeDialog.emit({})
  }
}
